<template>
  <div class>

    <sweet-modal ref="modal" width="900px" hide-close-button blocking>



       <p class="popup-save-title">{{ this.$t('ct-title-upgrade-popup-wait') }}</p>
       <p class="popup-save-message">
         {{ this.$t('ct-message-upgrade-popup-wait') }}
        </p>

        <div class="button-container">
          <div class="loading-gif">
              <img src="https://i.gifer.com/TqwF.gif" style="height: 100%" alt="">
          </div>
        </div>

      <button slot="button" @click="cancel()" class="btn btn-success mt-2 btn-publish" :class="{ 'btn-disabled': disabled }">{{ this.$t('ct-action-upgrade-popup') }}</button>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import axios from 'axios';
export default {
  props: ['show'],
  name: 'ModalUpgrade',
  components: {
    SweetModal
  },
  data() {
    return {
      disabled: 1,
      checked: 0,
      myInterval : ''
    };
  },
  watch: {
    show: function(value) {
      if (value){
        this.$refs.modal.open();
         this.disabled = 1;
         this.checkPlan();

        setTimeout( () => {
            this.disabled = 0;
        }, 5000 )
      }
      else this.$refs.modal.close();
    }
  },
  methods: {
    cancel() {
      if(this.disabled == 0){
        clearInterval(this.myInterval);
        this.$emit('closeAction');
      }
    },

    goToConnect(){
       clearInterval(this.myInterval);
        this.$emit('closeAction');
        this.$emit('upgrade');
    },

    checkPlan() {
        var vm = this;

      this.myInterval = setInterval(function() {
        if (vm.checked == 1){
              clearInterval(this.myInterval);
        }
        axios.get('http://localhost:8087/consulta')
        .then( (res) => {
          let data = res.data;
          if(data.is_free == 0){
            vm.checked = 1;
            console.log('passou');
            vm.goToConnect();
          }else{
            console.log('ainda nao pagou');
          }
        } )
      }, 5000);
    },


  },

};
</script>

<style lang="scss" scoped>




</style>



// WEBPACK FOOTER //
// src/components/dashboard/components/ModalUpgrade.vue